import { 
    message,
    Modal,
    Timeline,
    Divider  
} from 'antd'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { CopyOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import service from '../../../../../@services';
import './index.less'

const DeliveryInfo = props => {
    const {
      visible,
      onClose,
      detail = {},
      baseInfo
    } = props

    const [loading, setLoading] = useState(false)
    const [timeList, setTimeList] = useState([])
    const operationTypeMap = {
      1001: "仓库作业",
      1041: "已接单",
      2002: "已揽收",
      2003: "运输中",
      2004: "派件中",
      2006: "已收货"
    }

    const getList = async () => {
      let mobile = ''
      if(baseInfo && baseInfo.receiverPhone) {
        mobile = baseInfo.receiverPhone.substr(-4)
      }
      console.log(baseInfo)
      const data = {
        deliveryCode: detail.deliveryCode,
        phone: baseInfo.receiverPhone,
        to: baseInfo.receiverDetailAddr
      }
      // 调用快递100查询
      const res = await service.orderSend.getOrderDeliveryInfo(data)
      if(res) {
        console.log(res)
        const deliveryList = res.data.data
        const timeListTemp = deliveryList.map(item => {
          return {
              ...item
          };
        });
        setTimeList(timeListTemp)
      }
    }
    const onCopy = (str) => {
      copy(str);
      message.success('已复制到剪贴板')
    }
  
    useEffect(() => {
      if (visible) {
        getList()
      } else {
        
      }
    }, [visible])
    return (
      <Modal
        centered
        visible={visible}
        onCancel={onClose}
        width={760}
        okText="保存"
        footer={null}
        className='delivery-info-popup'
      >
        <div className='header'>
          <span className="title">物流信息</span>
          <div className='info'>
            <div className='name'>{ detail.deliveryCompany == 'jingdong' ? '京东物流' : detail.deliveryCompany }</div>
            <div className='code'>{ detail.deliveryCode }</div>
          </div>
          <div className='copy-box' onClick={() => onCopy(detail.deliveryCode)}>
            <CopyOutlined />
          </div>
        </div>
        <Divider plain></Divider>

        <Timeline 
          mode='left' 
          className='timeline' 
          style={{ display: timeList.length > 0 ? 'block' : 'none' }}
        >
          {
            timeList.map((item, index) => {
              return<Timeline.Item label={ item.status }>
                  <div className='timeline-item'>
                      <div>{ item.context }</div>
                      <div>{ item.time }</div>
                  </div>
              </Timeline.Item>
            })
          }
        </Timeline>
        <div 
          className='nodata-box'
          style={{ 
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
        >
          <img style={{ display: timeList.length > 0 ? 'none' : 'block'}} src="/assets/nodata.png" className='nodata-img' />
          <span style={{ display: timeList.length > 0 ? 'none' : 'block'}} className="nodata-text">暂无数据</span>
        </div>
      </Modal>
    )
  }
  export default connect(state => ({
  }))(DeliveryInfo)

